import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
    name: 'checklist',
    //pure: false
})
export class ChecklistPipe implements PipeTransform {
    constructor() {}
    transform(value: any, type: string = null, requirementid: any = null): any {
        if (Array.isArray(value)) {
            if (requirementid === null) {
                const status = value.find((item) => item.type == type)?.status;
                return status !== 'Accepted' ? false : true;
            } else {
                const status = value.find((item) => item.requirementid == requirementid)?.status;
                if (status) {
                    return status !== 'Accepted' ? false : true;
                }
                return false;
            }
        }
        return false;
    }
}
